import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _Toast from "antd-mobile/es/components/toast";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { css } from 'emotion';
import sample from 'lodash/sample';
import isEqual from 'lodash/isEqual';
import prizeStartImg from '@/images/prize-start.png';
import disabledImg from '@/images/disabled_btn.png';
import thanksImg from '@/images/thanks.png';
import { lotteryDraw, loadLatestLotteryInfo, lotteryUserInfo, getLocationMap as _getLocationMap } from '@/services/api';
import { traceOnError } from '@/tracer';
import { CaseUtil } from '@/utilities/common';
import pcBgImg from '@/images/lottery_pc_bg.png';
import mobileBgImg from '@/images/lottery_mobile_bg.png';
import pcLightBgImg from '@/images/lottery_pc_bg_light.png';
import headerImg from '@/images/lottery_header.png';
import latticeImg from '@/images/lottery_lattice.png';
import ModalMobile from './mobile/Lottery/Modal';
import ModalPC from './pc/Lottery/Modal';
import Cascader from './mobile/Lottery/Cascader';
var currentIndex = -1;
var jumps = 0;
var speed = 200;
var timer = 0;
var prize = -1;
var Preview = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Preview, _React$PureComponent);
  function Preview(props) {
    var _this;
    _classCallCheck(this, Preview);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Preview).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resetActive", function () {
      var id = "turntable-".concat(currentIndex + 1);
      var classVal = document.getElementById(id).getAttribute('class');
      classVal = classVal.replace('active', '');
      document.getElementById(id).setAttribute('class', classVal);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "runCircle", function () {
      if (currentIndex >= 0) {
        _this.resetActive();
      }
      currentIndex += 1;
      if (currentIndex > 7) {
        currentIndex = 0;
      }
      var newId = "turntable-".concat(currentIndex + 1);
      var newClass = document.getElementById(newId).getAttribute('class');
      newClass = newClass.concat(' active');
      document.getElementById(newId).setAttribute('class', newClass);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controllSpeed", function (_ref) {
      var prizeList = _ref.prizeList,
        prizeIndex = _ref.prizeIndex;
      var minimumJumps = _this.state.minimumJumps;
      jumps += 1;
      _this.runCircle();
      // 抽到奖品停止
      if (jumps > minimumJumps + 10 && prize === currentIndex) {
        var prizeName = prizeList[prize].prizeName;
        if (prizeName === '谢谢参与') {
          _this.setState({
            prizeTip: '很遗憾未中奖'
          });
        } else {
          _this.setState({
            prizeTip: "\u606D\u559C\u62BD\u4E2D".concat(prizeName, "\uFF01")
          });
          _this.setState({
            prizeModalVisible: true
          });
        }
        clearTimeout(timer);
        prize = -1;
        jumps = 0;
        // 没抽中继续
      } else {
        if (jumps < minimumJumps) {
          speed -= 10;
          //  决定奖品的位置
        } else if (jumps === minimumJumps) {
          prize = prizeIndex;
        } else {
          // 下一个就是奖品时放慢
          if (jumps > minimumJumps + 10 && prize === currentIndex + 1) {
            speed += 300;
          } else {
            speed += 20;
          }
        }
        if (speed < 40) {
          speed = 40;
        }
        timer = setTimeout(function () {
          _this.controllSpeed({
            prizeList: prizeList,
            prizeIndex: prizeIndex
          });
        }, speed);
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submitUserInfo", function (info) {
      var location = _this.state.location;
      var lotteryParams = _this.props.lotteryParams;
      var uid = lotteryParams.uid,
        did = lotteryParams.did;
      var pathname = window.location.pathname.replace(/\/$/, '');
      var ret = pathname.split('/'); // pathname一般都是 '/iGHria' 或 '/q/10666/DS4ut1N2/12c5/'
      var questionnaire_id = ret[2];
      var contact = _objectSpread({}, info, {
        address: location.join('') + info.address
      });
      var params = {
        questionnaire_id: questionnaire_id,
        user_id: uid,
        device_id: did,
        contact: contact
      };
      return new Promise(function (resolve, reject) {
        lotteryUserInfo(params).then(function (res) {
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeModal", function () {
      _this.setState({
        prizeModalVisible: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openCascader", function () {
      _this.setState({
        showLocCascader: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeCascader", function () {
      _this.setState({
        showLocCascader: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeLocation", function () {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (location.length < 3) {
        _Toast.show({
          content: '请选择完整地址',
          duration: 3
        });
      } else {
        _this.setState({
          location: location
        });
        _this.closeCascader();
      }
    });
    _this.state = {
      turntableList: _toConsumableArray(Array(8)).map(function (_) {
        return {
          prizeName: '',
          imgUrl: ''
        };
      }),
      prizeModalVisible: false,
      prizeInfo: null,
      minimumJumps: 15,
      // 超过开始进入抽奖
      disabled: false,
      prizeTip: '幸运大抽奖，立即参与',
      showLocCascader: false,
      location: [],
      locationMap: [],
      latestLotteryInfo: _objectSpread({}, props.lotteryInfo)
    };
    return _this;
  }
  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getLocationMap();
    }
  }, {
    key: "getLatestLotteryInfo",
    value: function getLatestLotteryInfo(_ref2) {
      var _this2 = this;
      var prizeList = _ref2.prizeList;
      var lotteryParams = this.props.lotteryParams;
      loadLatestLotteryInfo(lotteryParams).then(function (resp) {
        if (resp.code === 200) {
          var latestLotteryInfo = resp.data.lottery_v3;
          if (!isEqual(latestLotteryInfo, _this2.state.latestLotteryInfo)) {
            _Toast.show({
              content: '奖品配置已更新',
              position: 'top',
              duration: 1000
            });
            _this2.setState({
              latestLotteryInfo: latestLotteryInfo
            }, function () {
              var list = _this2.getPrizeList();
              setTimeout(function () {
                _this2.getLotteryResult({
                  prizeList: list
                });
              }, 1000);
            });
          } else {
            _this2.getLotteryResult({
              prizeList: prizeList
            });
          }
        }
      }).catch(function (error) {
        _Toast.show({
          content: error.message || '更新奖品失败，请联系问卷管理员',
          duration: 3
        });
      });
    }
  }, {
    key: "getLotteryResult",
    value: function getLotteryResult(_ref3) {
      var _this3 = this;
      var prizeList = _ref3.prizeList;
      var lotteryParams = this.props.lotteryParams;
      lotteryDraw(lotteryParams).then(function (resp) {
        var idxs = [];
        if (resp.data.win === 1) {
          var _CaseUtil$toCaml = CaseUtil.toCaml(resp.data),
            prizeInfo = _CaseUtil$toCaml.prizeInfo;
          _this3.setState({
            prizeInfo: prizeInfo
          });
          var _prizeInfo$position = prizeInfo.position,
            position = _prizeInfo$position === void 0 ? '' : _prizeInfo$position,
            type = prizeInfo.type;
          idxs = (position.split(',') || []).map(function (i) {
            return Number(i) - 1;
          });
          if (type === 0) {
            _this3.getLocationMap();
          }
        } else {
          prizeList.forEach(function (p, idx) {
            if (p.prizeName === '谢谢参与') {
              idxs.push(idx);
            }
          });
        }
        var prizeIndex = sample(idxs);
        _this3.controllSpeed({
          prizeList: prizeList,
          prizeIndex: prizeIndex
        });
      }).catch(function (error) {
        _Toast.show({
          content: error.message,
          duration: 3
        });
      });
      this.setState({
        disabled: true
      });
    }
  }, {
    key: "getLocationMap",
    value: function getLocationMap() {
      var _this4 = this;
      _getLocationMap('cn').then(function (res) {
        return _this4.setState({
          locationMap: res.data
        });
      }).catch(function (e) {
        traceOnError("".concat(e.message, "-").concat(window.location.href), e.code, 'Loc接口');
      });
    }
  }, {
    key: "getPrizeList",
    value: function getPrizeList() {
      var _latestLotteryInfo$pr;
      var _this$state = this.state,
        turntableList = _this$state.turntableList,
        latestLotteryInfo = _this$state.latestLotteryInfo;
      var prizeList = turntableList.map(function () {
        return {
          prizeName: '谢谢参与',
          imgUrl: thanksImg
        };
      });
      if (latestLotteryInfo === null || latestLotteryInfo === void 0 ? void 0 : (_latestLotteryInfo$pr = latestLotteryInfo.prizes) === null || _latestLotteryInfo$pr === void 0 ? void 0 : _latestLotteryInfo$pr.length) {
        latestLotteryInfo.prizes.forEach(function (prize, idx) {
          prizeList.forEach(function (item, index) {
            if (prize === null || prize === void 0 ? void 0 : prize.position.includes(String(index + 1))) {
              item.prizeName = prize.name;
              item.imgUrl = prize.img_url;
            }
          });
        });
      }
      return prizeList;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props = this.props,
        device = _this$props.device,
        showLottery = _this$props.showLottery;
      var ua = navigator.userAgent;
      var _this$state2 = this.state,
        prizeModalVisible = _this$state2.prizeModalVisible,
        prizeInfo = _this$state2.prizeInfo,
        disabled = _this$state2.disabled,
        prizeTip = _this$state2.prizeTip,
        showLocCascader = _this$state2.showLocCascader,
        location = _this$state2.location,
        locationMap = _this$state2.locationMap;
      var prizeList = this.getPrizeList();
      return React.createElement("div", {
        className: previewCls,
        style: {
          display: showLottery ? 'block' : 'none'
        }
      }, React.createElement("div", {
        className: "previewCont ".concat(device === 'mobile' && ua.indexOf('iPad') < 0 ? "phoneCont" : "pcCont")
      }, React.createElement("div", {
        className: "header"
      }, React.createElement("img", {
        src: device === 'mobile' ? headerImg : pcLightBgImg
      })), React.createElement("div", {
        className: "latticeCont"
      }, React.createElement("img", {
        src: latticeImg
      }), React.createElement("div", {
        className: "turntableCont"
      }, React.createElement("div", {
        className: "prizeTip"
      }, prizeTip), React.createElement("div", {
        className: "prizeCont"
      }, prizeList.map(function (prize, idx) {
        return React.createElement("div", {
          id: "turntable-".concat(idx + 1),
          className: "lattice turntable-".concat(idx + 1),
          tabIndex: "1",
          key: idx
        }, React.createElement("div", {
          className: "turntable-item"
        }, React.createElement("div", {
          className: "prizeImg"
        }, React.createElement("img", {
          src: prize.imgUrl
        }), React.createElement("div", {
          className: "shadowCont"
        })), React.createElement("div", {
          className: "prizeName"
        }, prize.prizeName)));
      }), React.createElement("div", {
        className: "lattice turntable-9",
        style: {
          cursor: disabled ? 'not-allowed' : 'pointer'
        },
        onClick: function onClick() {
          !disabled && _this5.getLatestLotteryInfo({
            prizeList: prizeList
          });
        }
      }, React.createElement("img", {
        src: disabled ? disabledImg : prizeStartImg
      })))))), prizeModalVisible && (device === 'mobile' ? React.createElement(ModalMobile, {
        prizeInfo: prizeInfo,
        location: location,
        submit: this.submitUserInfo,
        closeModal: this.closeModal,
        openCascader: this.openCascader
      }) : React.createElement(ModalPC, {
        prizeInfo: prizeInfo,
        locationMap: locationMap,
        submit: this.submitUserInfo,
        closeModal: this.closeModal,
        openCascader: this.openCascader
      })), React.createElement(Cascader, {
        location: location,
        cascaderVisible: showLocCascader,
        locationMap: locationMap,
        changeLocation: this.changeLocation,
        closeCascader: this.closeCascader
      }));
    }
  }]);
  return Preview;
}(React.PureComponent);
export { Preview as default };
var previewCls = /*#__PURE__*/css("width:100%;height:100%;z-index:1000;.previewCont{height:100%;overflow:auto;&.phoneCont{background:url(", mobileBgImg, ") no-repeat;background-size:100% 100%;width:100%;margin:auto;height:100%;.header{@media only screen and (orientation:landscape){width:368px;}margin:auto;margin-bottom:2px;margin-top:-30px;img{width:100%;}}.latticeCont{@media only screen and (orientation:landscape){width:400px;}width:100%;height:auto;.turntableCont{position:absolute;top:32px;left:40px;right:40px;bottom:50px;}}.prizeCont{margin-top:16px;.lattice{.prizeName{height:24px;line-height:24px;font-weight:500;}.prizeImg{.shadowCont{margin-top:8%;}}}}}&.pcCont{background:url(", pcBgImg, ") no-repeat;background-size:100% 100%;.header{position:absolute;width:900px;top:0px;left:50%;transform:translate(-50%);z-index:1;img{margin-left:58px;}}.latticeCont{width:448px;margin-top:196px;z-index:10;.turntableCont{position:absolute;top:37px;left:44px;right:44px;bottom:62px;}}.prizeTip{line-height:28px;font-size:14px;font-weight:600;}.prizeCont{margin-top:16px;}}.latticeCont{position:relative;margin:auto;}.prizeTip{width:70%;line-height:24px;margin:auto;text-align:center;color:#fff;background:linear-gradient( 90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.25) 56.25%,rgba(255,255,255,0) 100% );font-weight:500;}.prizeCont{width:100%;height:calc(100% - 44px);margin:auto;padding:16px;position:relative;.lattice{position:absolute;width:calc(33.33% - 8px);height:calc(33.33% - 8px);text-align:center;font-size:14px;color:#1c1f23;z-index:1;.turntable-item{width:100%;height:100%;background:#d7ddf6;box-shadow:0px 4px 4px rgba(52,75,168,0.35),inset 0px 2px 1px rgba(255,255,255,0.55);border-radius:12px;}&.active{&::after{content:'';width:calc(100% + 8px);height:calc(100% + 8px);position:absolute;top:-4px;left:-4px;right:0;bottom:0;background:linear-gradient(135deg,#fae05f 0%,#fa965c 100%);box-shadow:0px 4px 4px rgba(52,75,168,0.35),inset -1px -1px 1px #f26805,inset 0.75px 0.75px 0.75px rgba(255,255,255,0.65);border-radius:14px;z-index:-1;}}.prizeImg{width:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-70%);img{width:36%;}.shadowCont{width:34%;height:6px;margin:0 auto;margin-top:10px;border-radius:50%;background:rgba(22,65,138,0.12);filter:blur(2px);}}.prizeName{width:100%;padding:0 6px;text-align:center;height:26px;line-height:26px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:absolute;bottom:0;background:#fff;border-radius:0px 0px 12px 12px;color:#3c5aff;font-weight:600;.semi-icon{margin-left:4px;font-size:12px;}}.semi-icon-plus{font-size:18px;color:rgba(28,31,35,0.6);}}.turntable-1{top:0;left:0;}.turntable-2{top:0;left:calc(33.33% + 4px);}.turntable-3{top:0;right:0;}.turntable-4{top:calc(33.33% + 4px);right:0px;}.turntable-5{top:calc(66.66% + 8px);right:0px;}.turntable-6{top:calc(66.66% + 8px);left:calc(33.33% + 4px);}.turntable-7{top:calc(66.66% + 8px);left:0;}.turntable-8{top:calc(33.33% + 4px);left:0px;}.turntable-9{display:flex;align-items:center;top:50%;left:50%;transform:translate(-50%,-50%);border:0;background:none;box-shadow:none;color:rgba(28,31,35,0.35);cursor:pointer;filter:drop-shadow(0px 4px 4px rgba(52,75,168,0.45));img{width:100%;}}}}.adm-center-popup-wrap{width:calc(100% - 32px);min-width:unset;max-width:unset;.adm-center-popup-wrap{&:first-child{position:relative;}}.adm-modal-body{max-height:80vh;overflow:inherit;padding-top:0;}.adm-modal-content{padding:0;padding:0;position:relative;overflow:inherit;}}");